export const plantQueryKeys = {
  all: ['plantList'] as const,
  list: () => [...plantQueryKeys.all] as const,
  detail: (plantId: string) => [...plantQueryKeys.all, { plantId }] as const,
};
